'use client'

import { useMemo } from 'react'

import { AppRoute } from '@common/enums'

import { useLayoutStore } from '@stores/layout/layout.store'

import { handleNewActionClick } from '../utils/handleNewActionClick'

import { createHelpClickHandler } from './useHelpNavigation'
import { useNavigateTo } from './useNavigateTo'
import { useProjectSelect } from './useProjectSelect'
import { useWorkspaceSelect } from './useWorkspaceSelect'

type UseLayoutNavigationParams = {
  isPortal: boolean
}

export function useLayoutNavigation({ isPortal }: UseLayoutNavigationParams) {
  const { navigateTo, navigateOrRedirect, router } = useNavigateTo({ isPortal })
  const { handleProjectSelect, openProjectDialogOrRedirect } = useProjectSelect({ isPortal })
  const { handleWorkspaceSelect } = useWorkspaceSelect({ isPortal })
  const setFeedbackPopoverOpen = useLayoutStore((state) => state.setFeedbackPopoverOpen)
  const handleHelpClick = useMemo(() => createHelpClickHandler({ setFeedbackPopoverOpen }), [setFeedbackPopoverOpen])

  return {
    handleNewActionClick: (item: string) =>
      handleNewActionClick(item, { navigateTo, navigateOrRedirect, openProjectDialogOrRedirect }),
    handleAddServiceClick: () => navigateTo(AppRoute.SERVICE_DEPLOYMENT_METHOD),
    handleAddProjectClick: openProjectDialogOrRedirect,
    handleAddWorkspaceClick: () => navigateOrRedirect(AppRoute.WORKSPACE_CREATE),
    handleProfileClick: (item: string) => {
      if (item === AppRoute.LOGOUT) router.push(AppRoute.LOGOUT)
      if (item === AppRoute.SETTINGS) navigateOrRedirect(AppRoute.SETTINGS)
    },
    handleHelpClick,
    handleNavigationClick: navigateTo,
    handleProjectSelect,
    handleWorkspaceSelect,
    handleOpenWorkspaceSettings: () => navigateOrRedirect(AppRoute.SETTINGS_WORKSPACE),
    handleOpenProjectSettings: () => navigateOrRedirect(AppRoute.SETTINGS_PROJECT),
    handleOpenProjectMembers: () => navigateOrRedirect(AppRoute.SETTINGS_PROJECT_MEMBERS),
    handleInviteProjectClick: () => useLayoutStore.getState().openInviteProjectDialog(),
    handleInviteWorkspaceClick: () => useLayoutStore.getState().openInviteWorkspaceDialog(),
  }
}
